import { HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Panel from "@ui/panel/Panel";
import Spacer from "@ui/spacer/Spacer";
import { useTranslation } from "react-i18next";
import { RankingLegend } from "./RankingCard";
import { getRankingMax } from "./rankingData";
import { RANKING_FONT } from "./rankingTheme";
import { PALETTE } from "./constants";
import { S_BAR_CHART_SECTIONAL_DETAILS } from "./signals";
import { SectionalBarList } from "./SectionalBarList";

export const BarChartSectionalDetailsPopup = () => {
	const { t } = useTranslation();
	const requestData = S_BAR_CHART_SECTIONAL_DETAILS.use();
	if (!requestData) return null;
	const close = () => S_BAR_CHART_SECTIONAL_DETAILS.invoke(null);
	const colors = requestData.legend?.colors ?? PALETTE;
	const labels = requestData.legend?.labels ?? [];
	const displayData = requestData.data.map(d => ({
		...d,
		value: d.value.map(Number),
	}));
	const longLabels = displayData.some(d => d.label.length > 10);
	const maxTotal = getRankingMax(displayData);
	return (
		<Panel sx={{ width: "600px", maxWidth: "90vw", maxHeight: "90vh", overflow: "hidden", fontFamily: RANKING_FONT, fontSize: "13px", lineHeight: 1.45, color: "#344054" }} decorator="absolute" disableScroll growContent label={requestData.title} onClose={close}>
			<RankingLegend labels={labels} colors={colors} />
			<VBox sx={{ gap: "12px", flex: 1, minHeight: 0, overflow: "auto", padding: "4px", paddingRight: "12px" }}>
				<SectionalBarList data={displayData} colors={colors} labels={labels} maxTotal={maxTotal} longLabels={longLabels} icon={requestData.icon}
					getRowAction={requestData.getRowAction ? label => {
						const action = requestData.getRowAction?.(label);
						return action ? { ...action, onClick: () => { close(); action.onClick(); } } : undefined;
					} : undefined} />
			</VBox>
			<Spacer size="20px" />
			<HBox sx={{ justifyContent: "end" }}>
				<Button title={t("common.close")} variant="secondary" onClick={close} />
			</HBox>
		</Panel>
	);
};
